import { useMemo } from "react";
import { SettingsItem } from "@vms/AiResult/AiResultSettings";
import { getSettingsColumns, useGetAiSettingsFilters } from "@vms/SelectFilters/useGetAiSettingsFilters";
import {
    BYO_DEFAULT_ANALYTIC_TYPE,
    BYO_DEFAULT_VALUE_TYPE,
    ByoAnalyticType,
    ByoValueType,
    getGrowthColumn,
    getIsTableSlice,
    getSliceName,
    SlicesEnum
} from "@models/Byo";
import { getByoAnalyticTypeName } from "@pages/Byo/components/AnalyticsTypeTabs/AnalyticsTypeTabs";
import { DEFAULT_GROWTH_PERIOD } from "@constants/general";
import { useAiSearchSettingsContext } from "@vms/AiSearchSettingsContext/AiSearchSettingsContext";

export function useAiSearchByoSettings() {
    const {
        isLoading: isAiSearchSettingsLoading,
        byoSettings,
    } = useAiSearchSettingsContext();
    const getAiSettingsFilters = useGetAiSettingsFilters();

    return useMemo(
        (): SettingsItem[][] => {
            if (isAiSearchSettingsLoading) return [];
            if (!byoSettings) return [];

            const {
                apiFilters,
                activeAnalyticsType: activeAnalyticsTypeRaw,
                activeValueType: activeValueTypeRaw,
                activeSliceId: activeSliceIdRaw,
                semanticFilter,
                yearsGrowth,
            } = byoSettings;

            let filtersSettings: SettingsItem[] = [];

            if (apiFilters) {
                filtersSettings = getAiSettingsFilters(apiFilters);
            }

            const settingsColumns = getSettingsColumns(filtersSettings);




            const activeAnalyticsType = activeAnalyticsTypeRaw ?? BYO_DEFAULT_ANALYTIC_TYPE;
            let activeValueType = activeValueTypeRaw ?? BYO_DEFAULT_VALUE_TYPE;

            if (activeAnalyticsType === ByoAnalyticType.Count) {
                activeValueType = ByoValueType.Count
            }
            const activeSliceId = getIsTableSlice(activeSliceIdRaw)
                ? activeSliceIdRaw
                : SlicesEnum.Segments;

            const values: SettingsItem['values'] = [
                {
                    id: 'activeAnalyticsType',
                    title: `Data Type: ${getByoAnalyticTypeName(activeAnalyticsType)} ${activeValueType === ByoValueType.Count ? '#' : '%'}`,
                },
                {
                    id: 'activeSliceId',
                    title: `Show by: ${getSliceName(activeSliceId)}`,
                },
            ];


            if (
                yearsGrowth !== null
                && yearsGrowth !== undefined
                && yearsGrowth !== DEFAULT_GROWTH_PERIOD
            ) {
                values.push({
                    id: 'yearsGrowth',
                    title: `Past Growth Years Timeframe: ${getGrowthColumn(yearsGrowth)}`,
                });
            }

            if (semanticFilter) {
                values.push({
                    id: 'semanticFilter',
                    title: `Semantic filter: ${semanticFilter}`,
                });
            }

            settingsColumns[1].unshift({
                id: 'general',
                title: 'BYO Settings',
                values,
            });

            return settingsColumns;
        },
        [
            isAiSearchSettingsLoading,
            getAiSettingsFilters,
            byoSettings
        ]
    );
}